@if (active()) {
  @if (compact()) {
    <vx-icon-button
      icon="bell-slash"
      variant="ghost"
      tone="secondary"
      [ariaLabel]="'components.sidebar.toastSnooze.resume' | transloco"
      [vxTooltip]="'components.sidebar.toastSnooze.resume' | transloco"
      vxTooltipSide="right"
      (click)="snooze.resume()" />
  } @else {
    <div
      class="flex items-center gap-2 rounded-lg bg-zinc-900 py-1.5 ps-3 pe-1.5">
      <vx-icon name="bell-slash" size="sm" class="shrink-0 text-zinc-400" />
      <span class="min-w-0 flex-1 text-xs tracking-tight text-zinc-400">
        @if (snooze.allSnoozedUntil(); as until) {
          {{
            'components.sidebar.toastSnooze.all'
              | transloco
                : {
                    until:
                      until | localeDate: untilStyle() : { timeStyle: 'short' },
                  }
          }}
        } @else {
          {{
            'components.sidebar.toastSnooze.incidents'
              | transloco: { count: snooze.snoozedIncidentCount() }
          }}
        }
      </span>
      <vx-button
        size="sm"
        variant="ghost"
        tone="secondary"
        (click)="snooze.resume()">
        {{ 'components.sidebar.toastSnooze.resumeShort' | transloco }}
      </vx-button>
    </div>
  }
}
